export default __webpack_public_path__ + "static/media/Component48–2.e05431be.svg";